import type { IAdvertiser } from '@/Interfaces/Advertiser.interface';
import type { IBeeswaxFirstPartySegment } from '@/Interfaces/Beeswax/FirstPartySegment.interface';
import type { IBeeswaxFirstPartySegmentControlOption } from '@/Interfaces/ControlOption.interface';

const getSegmentControlOption = ({ key, name }: IBeeswaxFirstPartySegment): IBeeswaxFirstPartySegmentControlOption => ({
  value: key,
  label: name,
  displayKey: key?.replace(/[^\d]/g, '') || '',
});

export const firstPartyBeeswaxSegmentsByAdvertiser = (
  segments: IBeeswaxFirstPartySegment[] = [],
): Record<IAdvertiser['id'], IBeeswaxFirstPartySegmentControlOption[]> => {
  const segmentsByAdvertiser: Record<IAdvertiser['id'], IBeeswaxFirstPartySegmentControlOption[]> = {};
  segments.forEach(segment => {
    const { advertiserId } = segment;
    if (!segmentsByAdvertiser[advertiserId]) {
      segmentsByAdvertiser[advertiserId] = [];
    }
    segmentsByAdvertiser[advertiserId].push(getSegmentControlOption(segment));
  });
  return segmentsByAdvertiser;
};

export const firstPartyBeeswaxSegmentsToControlOptions = (
  segments: IBeeswaxFirstPartySegment[] = [],
): IBeeswaxFirstPartySegmentControlOption[] => {
  return segments.map(segment => getSegmentControlOption(segment));
};
